<template>
  <v-container fluid class="container_bg">

    <v-row justify="center" dense class="mt-5">
      <v-col cols="12" md="11">
        <h1>{{this.$i18n.locale == 'ko' ? '참가자등록' : 'Visitor Edit'}}</h1>
      </v-col>
    </v-row>
    
    <v-divider/> 
    
    <v-row justify="center" dense class="mt-5">
      <v-col cols="12" md="11">
        <p>{{this.$i18n.locale == 'ko' ? '참가자 정보를 수정합니다.' : 'Modify participant information.'}}</p>
      </v-col>
    </v-row>

    <v-row justify="center" dense class="mt-5">
      <v-col cols="12" md="11">
        <h3>HTTP Request</h3>
      </v-col>
    </v-row>
    <v-row justify="center" dense>
      <v-col cols="12" md="3" class="fieldname d-flex justify-center align-center">POST</v-col>
      <v-col cols="12" md="8" class="fielddesc">/fsApi/VisitorUpdate</v-col>
    </v-row>
    
    <v-row justify="center" dense class="mt-5">
      <v-col cols="12" md="11">
        <h3>Request Body</h3>
        <template v-if="$i18n.locale == 'ko'">
          요청 파라메터는 아래 표를 참고하세요. 요청 파라메터의 타입은 x-www-form-urlencoded 입니다.
        </template>
        <template v-else>
          Refer to the table below for request parameters. The request parameter type is x-www-form-urlencoded.
        </template>
      </v-col>
    </v-row>
    
    <v-row justify="center" dense>

      <!-- 공통 -->
      <v-col cols="12" md="3" class="fieldname d-flex justify-center align-center">VISITOR_IDX</v-col>
      <v-col cols="12" md="8" class="fielddesc" align-center="center">Number | <strong>Required</strong><br>
        <template v-if="$i18n.locale == 'ko'">
          수정대상 참가자의 IDX값
        </template>
        <template v-else>
          IDX value of correction target participant
        </template>
      </v-col>
      <v-col cols="12" md="3" class="fieldname d-flex justify-center align-center">OPTION_IDX</v-col>
      <v-col cols="12" md="8" class="fielddesc" align-center="center">Number | <strong>Required</strong><br>
        <template v-if="$i18n.locale == 'ko'">
          수정하실 입장료 옵셥 IDX값
        </template>
        <template v-else>
          Admission fee to be revised IDX value
        </template>
      </v-col>
      <v-col cols="12" md="3" class="fieldname d-flex justify-center align-center">NAME</v-col>
      <v-col cols="12" md="8" class="fielddesc" align-center="center">String | <strong>Required</strong><br>
        <template v-if="$i18n.locale == 'ko'">
          수정하실 이름을 입력합니다.<br>한글이 깨지는 경우 escape해서 보내주세요.
        </template>
        <template v-else>
          Enter the name you want to modify.<br>If the Korean is broken, please escape it and send it to me.
        </template>
      </v-col>
      <v-col cols="12" md="3" class="fieldname d-flex justify-center align-center">TEL</v-col>
      <v-col cols="12" md="8" class="fielddesc" align-center="center">String | <strong>Required</strong><br>
        <template v-if="$i18n.locale == 'ko'">
          수정하실 참가자의 전화번호를 입력합니다. 전화번호는 특수문자를 제거하고 숫자만 보내주세요.
        </template>
        <template v-else>
          Enter the phone number of the participant you want to modify. Please remove special characters from the phone number and send only numbers.
        </template>
      </v-col>
       <v-col cols="12" md="3" class="fieldname d-flex justify-center align-center">GENDER</v-col>
      <v-col cols="12" md="8" class="pa-0" align-center="center">
        <table>
          <tr><td width="100%" colspan="2">Number | <strong>Required</strong><br>{{this.$i18n.locale == 'ko' ? '참가자의 성별을 입력합니다.' : 'Enter the gender of the participant.'}}</td></tr>
          <tr><td width="20%" style="text-align:center">1</td><td width="80%">{{this.$i18n.locale == 'ko' ? '남성' : 'male'}}</td></tr>
          <tr><td width="20%" style="text-align:center">2</td><td width="80%">{{this.$i18n.locale == 'ko' ? '여성' : 'female'}}</td></tr>
        </table>
      </v-col>      
      <v-col cols="12" md="3" class="fieldname d-flex justify-center align-center">EMAIL</v-col>
      <v-col cols="12" md="8" class="fielddesc" align-center="center">String<br>
        <template v-if="$i18n.locale == 'ko'">
          참가자의 이메일을 입력합니다.<br>문자열 값은 escape해서 보내주세요.
        </template>
        <template v-else>
          Enter the participant's email.<br>Please send me the value of the string after escape it.
        </template>
      </v-col>
      <v-col cols="12" md="3" class="fieldname d-flex justify-center align-center">INFO2</v-col>
      <v-col cols="12" md="8" class="fielddesc" align-center="center">String<br>
        <template v-if="$i18n.locale == 'ko'">
          참가자 기본등록양식 정보를 입력합니다.<br>한글이 깨지는 경우 escape해서 보내주세요.
        </template>
        <template v-else>
          Enter participant default registration form information.<br>If the Korean is broken, please escape it and send it to me.
        </template>
      </v-col>
      <v-col cols="12" md="3" class="fieldname d-flex justify-center align-center">INFO3</v-col>
      <v-col cols="12" md="8" class="fielddesc" align-center="center">String<br>
        <template v-if="$i18n.locale == 'ko'">
          참가자 기본등록양식 정보를 입력합니다.<br>한글이 깨지는 경우 escape해서 보내주세요.
        </template>
        <template v-else>
          Enter participant default registration form information.<br>If the Korean is broken, please escape it and send it to me.
        </template>
      </v-col>
      <v-col cols="12" md="3" class="fieldname d-flex justify-center align-center">INFO4</v-col>
      <v-col cols="12" md="8" class="fielddesc" align-center="center">String<br>
        <template v-if="$i18n.locale == 'ko'">
          참가자 기본등록양식 정보를 입력합니다.<br>한글이 깨지는 경우 escape해서 보내주세요.
        </template>
        <template v-else>
          Enter participant default registration form information.<br>If the Korean is broken, please escape it and send it to me.
        </template>
      </v-col>
      <v-col cols="12" md="3" class="fieldname d-flex justify-center align-center">INFO5</v-col>
      <v-col cols="12" md="8" class="fielddesc" align-center="center">String<br>
        <template v-if="$i18n.locale == 'ko'">
          참가자 기본등록양식 정보를 입력합니다.<br>한글이 깨지는 경우 escape해서 보내주세요.
        </template>
        <template v-else>
          Enter participant default registration form information.<br>If the Korean is broken, please escape it and send it to me.
        </template>
      </v-col>
      <v-col cols="12" md="3" class="fieldname d-flex justify-center align-center">INFO6</v-col>
      <v-col cols="12" md="8" class="fielddesc" align-center="center">String<br>
        <template v-if="$i18n.locale == 'ko'">
          참가자 기본등록양식 정보를 입력합니다.<br>한글이 깨지는 경우 escape해서 보내주세요.
        </template>
        <template v-else>
          Enter participant default registration form information.<br>If the Korean is broken, please escape it and send it to me.
        </template>
      </v-col>
      <v-col cols="12" md="3" class="fieldname d-flex justify-center align-center">INFO7</v-col>
      <v-col cols="12" md="8" class="fielddesc" align-center="center">String<br>
        <template v-if="$i18n.locale == 'ko'">
          참가자 기본등록양식 정보를 입력합니다.<br>한글이 깨지는 경우 escape해서 보내주세요.
        </template>
        <template v-else>
          Enter participant default registration form information.<br>If the Korean is broken, please escape it and send it to me.
        </template>
      </v-col>
      <v-col cols="12" md="3" class="fieldname d-flex justify-center align-center">INFO8</v-col>
      <v-col cols="12" md="8" class="fielddesc" align-center="center">String<br>
        <template v-if="$i18n.locale == 'ko'">
          참가자 기본등록양식 정보를 입력합니다.<br>한글이 깨지는 경우 escape해서 보내주세요.
        </template>
        <template v-else>
          Enter participant default registration form information.<br>If the Korean is broken, please escape it and send it to me.
        </template>
      </v-col>
      <v-col cols="12" md="3" class="fieldname d-flex justify-center align-center">INFO9</v-col>
      <v-col cols="12" md="8" class="fielddesc" align-center="center">String<br>
        <template v-if="$i18n.locale == 'ko'">
          참가자 기본등록양식 정보를 입력합니다.<br>한글이 깨지는 경우 escape해서 보내주세요.
        </template>
        <template v-else>
          Enter participant default registration form information.<br>If the Korean is broken, please escape it and send it to me.
        </template>
      </v-col>
      <v-col cols="12" md="3" class="fieldname d-flex justify-center align-center">INFO10</v-col>
      <v-col cols="12" md="8" class="fielddesc" align-center="center">String<br>
        <template v-if="$i18n.locale == 'ko'">
          참가자 기본등록양식 정보를 입력합니다.<br>한글이 깨지는 경우 escape해서 보내주세요.
        </template>
        <template v-else>
          Enter participant default registration form information.<br>If the Korean is broken, please escape it and send it to me.
        </template>
      </v-col>

    </v-row>

    
    <v-row justify="center" dense class="mt-5">
      <v-col cols="12" md="11">
        <h3>Response Body</h3>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="12" md="11" class="fieldname"><h4>JSON representation</h4></v-col>
      <v-col cols="12" md="11" class="fielddesc pa-0">
        <pre translate="no" style="background:#fafafa">
        {
          "resultCode": 0,
        }          
        </pre>
      </v-col>
    </v-row>
    <v-row justify="center" dense>
      <v-col cols="12" md="3" class="fieldname d-flex justify-center align-center">resultCode</v-col>
      <v-col cols="12" md="8" class="fielddesc" align-center="center"><a @click="nav('apiCommon')">{{this.$i18n.locale == 'ko' ? '여기를 눌러서 상세한 코드값을 확인하세요.' : 'Click here to see the detailed code values.'}}</a></v-col>
    </v-row>

    <v-row justify="center" dense class="mb-15">
      <v-col cols="12" md="11">
      </v-col>
    </v-row>    


  </v-container>
</template>
<script>

export default {

    mounted() {

    },

    data: () => ({
      tab:0
    }),

    methods: {

      nav(name){
        this.$router.push("/ApiDoc/"+name).catch(()=>{});
      },

    },

    created(){
      //apiProductList
    }


}
</script>

<!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
<style scoped>

table{
  width: 100%;
  border-collapse: collapse;
}
th, td {
  border: 1px solid #eaeaea;
  padding: 10px;
}
.fieldname {
  background: #f1f3f4;
  border: 1px solid #eaeaea;
}
.fielddivider {
  background: #464646;
  border: 1px solid #eaeaea;
  color: white;
}
.fielddesc {
  border: 1px solid #eaeaea;
  padding-left: 15px;
  padding-right: 15px;
}

</style>